import { LineChart } from 'lucide-react'
import { EmptyState, PageHeader } from '@/components/ui'

export function BwaPage() {
  return (
    <div className="p-6 max-w-7xl mx-auto">
      <PageHeader
        title="BWA & Liquidität"
        description="Betriebswirtschaftliche Auswertung und Liquiditätsforecast pro Mandant"
      />
      <EmptyState
        icon={<LineChart className="w-12 h-12" />}
        title="In Vorbereitung"
        description="Diese Ansicht wird BWA-Kennzahlen aus SAP zusammen mit aktuellen Bank-Salden auswerten und einen rollierenden Liquiditätsforecast erstellen."
      />
    </div>
  )
}
